module.exports = __webpack_public_path__ + "static/img/mlogo.1890cde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mlogo.png
// module id = qz1O
// module chunks = 1